import styled from "@emotion/styled";
export const StyledSignupButton = styled.div``;
